export const PAGE_ORIGIN = { x: 0, y: 0 };

// A page or column break is laid out with no height; its mark still needs a visible band.
export const MIN_MARK_HEIGHT_PT = 4;
